import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'

import { simpleFetch } from '../actions/acCommon'
import { bookingDetailsDataChange, submitBookingMessage } from '../actions/acBookingDetails'
import { parseQuery } from '../helpers/queryHelpers'

import { BookingStatusBadge, PootsyTitle, MapMarker, PrimaryLink } from './DesignFunctions'
import { PootsyTextArea } from './InputsFunctions'
import { womanAvatar, manAvatar } from '../static/svg/avatars'
import TimelineLayout from './TimelineLayout'
import ActivityCell from './ActivityCell'

const defaultMapCenter = { lat: 50.845, lng: 4.354 } // < defaults to centering on brussels
class BookingDetails extends Component {
	componentWillMount = () => {
		let { dispatch, location, match: { params } } = this.props
		let url = "/customers/bookings/" + params.id
		let init = { method: 'GET' }
		let query = parseQuery(location.search)
		if(query.date){
			url += '?recurrence_date=' + query.date
		}
		dispatch(simpleFetch(url, init, 'FETCHBOOKING'))
	}
	renderDetails = booking => {
		let { t } = this.context
		const rightInfos = [
			{ label: t('date'), value: booking.start.format('dddd DD.MM.YYYY') },
			{ label: t('time'), value: `${t('from')} ${booking.start.format('HH:mm')} ${t('to')} ${booking.end.format('HH:mm')}` },
			{ label: t('recurrence'), value: t(booking.recurrence) },
			{ label: t('address'), value: booking.address.inline },
		]
		return rightInfos.map(entry =>
			<div key={entry.label} className="detail">
				<div className="label">{entry.label}</div>
				<div className="value">{entry.value}</div>
			</div>
		)
	}
	handleTextAreaChange = e => {
		if (e.target.value.includes("\n")) { return }
		this.props.dispatch(bookingDetailsDataChange({ currentMessage: e.target.value }))
	}
	handleSubmit = e => {
		let { dispatch } = this.props
		if(e.key === 'Enter'){ dispatch(submitBookingMessage()) }
	}
	render() {
		let { t } = this.context
		let { meta, booking } = this.props
		if(!meta.fetched){ return null }
		return(
			<div className="BookingDetails">
				<div className="left">
					<PootsyTitle title={`${t('service_for_date')} ${booking.start.format('DD.MM.YYYY')}`}/>
					<PootsyTextArea
						placeholder={t('feel_like_leaving_a_message')}
						value={booking.currentMessage}
						onChange={this.handleTextAreaChange}
						onKeyPress={this.handleSubmit}
					/>
					<TimelineLayout timelineItems={booking.activities.map(a => ({
						reactKey: a.id, date: a.date, content: <ActivityCell activity={a}/>
					}))}/>
				</div>
				<div className="right">
					<div className="booking-infos-box">
						<div className="red-border"/>
						<div className="header">
							<div className="worker-pic">{booking.workerTitle === 'mr' ? manAvatar : womanAvatar}</div>
							<div className="worker-affiliate">
								<div className="worker-name">{booking.workerName}</div>
								<div className="affiliate-name">{booking.affiliateName}</div>
							</div>
						</div>
						<BookingStatusBadge status={booking.status} t={t}/>
						<div className="details">{this.renderDetails(booking)}</div>
						<div className="maps-container">
							<GoogleMapReact
								zoom={13}
								defaultCenter={defaultMapCenter} // ( defined at top of file, otherwise there is a warning at each render because of redefining the variable )
								center={{ lat: booking.address.lat, lng: booking.address.lng }}
								bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
							>
								<MapMarker lat={booking.address.lat} lng={booking.address.lng}/>
							</GoogleMapReact>
						</div>
					</div>
					<div className="under-box">
						<div className="contact-prompt">{t('problem_with_service_prompt')}</div>
						<PrimaryLink to={"/affiliate/"+booking.affiliateId} label={t('contact_us')}/>
					</div>
				</div>
			</div>
		)
	}
}

BookingDetails.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	booking: state.dataReducer.booking,
	meta: state.metadataReducer.booking,
})
export default connect(mapStateToProps)(BookingDetails);



// WEBPACK FOOTER //
// ./src/components/BookingDetails.js